class QueriesController {
    constructor($http, $scope, DTOptionsBuilder, DTColumnBuilder, User, Constants,
        CONST, materialButtons, datePicker, $rootScope, FunctionService, QueryModalOptions, CoderService) {

        $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
        this.datatableApi;
        this.user = User.getUser();
        this.name = 'Queries';
        this.episodeValue = '';
        this.separationString = '';
        this.showAdmissionNumberColumn = false;
        this.showAuditTypeColumn = false;
        this.showClinicianResponseColumn = false;
        this.showQueryByColumn = false;
        this.showQueryReasonColumn = false;
        this.showSendsColumns = false;
        this.queryAuditTypeTableUrl = 'queryaudittype/base';
        this.functionSettings = {};
        this.locale = 'en-au';
        this.url = WEBSERVICEURL + '/dataagility/api/service.queriesreport';
        this.initUrl = this.url + '?startDate=' + moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L') + '&episodeActive=YES';
        this.specialtyString = '';
        this.totalProjectedWiesDifference = 0;

        FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
            function (response) {
                $scope.vm.functionSettings = response.functionSettings;
                $scope.vm.episodeValue = $scope.vm.functionSettings.EpisodeValue ? $scope.vm.functionSettings.EpisodeValue.valueString : '';
                $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
                $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
                $scope.vm.showQueryReasonColumn = $scope.vm.functionSettings.QueryReasonColumn ? $scope.vm.functionSettings.QueryReasonColumn.isActive : false;
                $scope.vm.showAuditTypeColumn = $scope.vm.functionSettings.AuditTypeColumn ? $scope.vm.functionSettings.AuditTypeColumn.isActive : false;
                $scope.vm.showClinicianResponseColumn = $scope.vm.functionSettings.ClinicianResponseColumn ? $scope.vm.functionSettings.ClinicianResponseColumn.isActive : false;
                $scope.vm.showQueryByColumn = $scope.vm.functionSettings.QueryByColumn ? $scope.vm.functionSettings.QueryByColumn.isActive : false;
                $scope.vm.showAdmissionNumberColumn = $scope.vm.functionSettings.AdmissionNumberReplacesUrn ? $scope.vm.functionSettings.AdmissionNumberReplacesUrn.isActive : false;
                $scope.vm.queryAuditTypeTableUrl = $scope.vm.functionSettings.QueryAuditTypeTableUrl ? $scope.vm.functionSettings.QueryAuditTypeTableUrl.valueString : $scope.vm.queryAuditTypeTableUrl;
                $scope.vm.showSendsColumns = $scope.vm.functionSettings.QuerySendReceive ? $scope.vm.functionSettings.QuerySendReceive.isActive : false;
                $scope.vm.showQueryCategoryColumn = $scope.vm.functionSettings.QueryCategory ? $scope.vm.functionSettings.QueryCategory.isActive : false;
                QueryModalOptions.types($scope.vm.queryAuditTypeTableUrl).then(function (data) {
                    angular.forEach(data, function (value, key) {
                        if ($scope.vm.queryTypeOptions.indexOf(value.name) === -1) {
                            $scope.vm.queryTypeOptions.push(value.name);
                        }
                    });
                });

                Constants.campusData().then(
                  function successCallback(response) {
                    if ($scope.vm.user.role !== 'Administrator' && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
                      let campusOptions = [];
                      if (typeof $scope.vm.user.campus === 'string') {
                        campusOptions = unescape($scope.vm.user.campus).split(','); // tslint:disable-line
                      } else {
                        campusOptions = unescape($scope.vm.user.campus.join()).split(','); // tslint:disable-line
                      }
                      $scope.vm.campusOptions = campusOptions;
                      $scope.vm.campus.selectedCampus = campusOptions;
                    } else {
                      $scope.vm.campusOptions = response;
                    }
                  }
                );

                if (!$scope.vm.showSendsColumns) {
                    var sendsColumns = $scope.vm.dtColumns.filter(x => x.mData === 'sentCount');
                    if (sendsColumns.length > 0) {
                        var indexOfSendsColumns = $scope.vm.dtColumns.indexOf(sendsColumns[0]);
                        $scope.vm.dtColumns.splice(indexOfSendsColumns, 2);
                    }
                }
                if (!$scope.vm.showQueryByColumn) {
                    var queryByColumns = $scope.vm.dtColumns.filter(x => x.mData === 'queryType');
                    if (queryByColumns.length > 0) {
                        var indexOfQueryByColumn = $scope.vm.dtColumns.indexOf(queryByColumns[0]);
                        $scope.vm.dtColumns.splice(indexOfQueryByColumn, 1);
                    }
                }
                if (!$scope.vm.showAdmissionNumberColumn) {
                    var admissionNumberColumns = $scope.vm.dtColumns.filter(x => x.mData === 'admissionNumber');
                    if (admissionNumberColumns.length > 0) {
                        var indexOfAdmissionNumberColumn = $scope.vm.dtColumns.indexOf(admissionNumberColumns[0]);
                        $scope.vm.dtColumns.splice(indexOfAdmissionNumberColumn, 1);
                    }
                }
                if (!$scope.vm.showQueryReasonColumn) {
                    var queryReasonColumns = $scope.vm.dtColumns.filter(x => x.mData === 'queryReason');
                    if (queryReasonColumns.length > 0) {
                        var indexOfQueryReasonColumn = $scope.vm.dtColumns.indexOf(queryReasonColumns[0]);
                        $scope.vm.dtColumns.splice(indexOfQueryReasonColumn, 1);
                    }
                }
                if (!$scope.vm.showClinicianResponseColumn) {
                    var clinicianResponseColumns = $scope.vm.dtColumns.filter(x => x.mData === 'clinicianResponse');
                    if (clinicianResponseColumns.length > 0) {
                        var indexOfClinicianResponseColumnsColumn = $scope.vm.dtColumns.indexOf(clinicianResponseColumns[0]);
                        $scope.vm.dtColumns.splice(indexOfClinicianResponseColumnsColumn, 1);
                    }
                }
                if (!$scope.vm.showQueryCategoryColumn) {
                    var queryCategoryColumns = $scope.vm.dtColumns.filter(x => x.mData === 'queryCategory');
                    if (queryCategoryColumns.length > 0) {
                        var indexOfQueryCategoryColumn = $scope.vm.dtColumns.indexOf(queryCategoryColumns[0]);
                        $scope.vm.dtColumns.splice(indexOfQueryCategoryColumn, 1);
                    }
                }
                var auditTypeColumns = $scope.vm.dtColumns.filter(x => x.mData === 'auditType');
                if (auditTypeColumns.length > 0) {
                    var auditTypeColumnIndex = $scope.vm.dtColumns.indexOf(auditTypeColumns[0]);
                    if (!$scope.vm.showAuditTypeColumn) {
                        $scope.vm.dtColumns.splice(auditTypeColumnIndex, 1);
                    } else {
                        $scope.vm.dtColumns[auditTypeColumnIndex].sTitle = $scope.vm.functionSettings.AuditTypeColumn ? $scope.vm.functionSettings.AuditTypeColumn.valueString : 'Audit Type'
                    }
                }
                var currentDrgColumns = $scope.vm.dtColumns.filter(x => x.mData === 'currentDrg');
                if (currentDrgColumns.length > 0) {
                    var indexOfCurrentDrgColumn = $scope.vm.dtColumns.indexOf(currentDrgColumns[0]);
                    $scope.vm.dtColumns[indexOfCurrentDrgColumn + 1].sTitle = 'Current ' + $scope.vm.episodeValue;
                    $scope.vm.dtColumns[indexOfCurrentDrgColumn + 2].sTitle = 'Projected ' + $scope.vm.episodeValue;
                    $scope.vm.dtColumns[indexOfCurrentDrgColumn + 3].sTitle = 'Projected<br>' + $scope.vm.episodeValue + ' Difference';
                    $scope.vm.dtColumns[indexOfCurrentDrgColumn + 4].sTitle = $scope.vm.episodeValue + ' Difference';
                }
                var dischargeDateColumn = $scope.vm.dtColumns.filter(x => x.mData === 'dischargeDate');
                if (dischargeDateColumn.length > 0) {
                    var indexOfDischargeDateColumn = $scope.vm.dtColumns.indexOf(dischargeDateColumn[0]);
                    $scope.vm.dtColumns[indexOfDischargeDateColumn].sTitle = $scope.vm.separationString + ' Date';
                }
                var specialtyColumn = $scope.vm.dtColumns.filter(x => x.mData === 'speciality');
                if (specialtyColumn.length > 0) {
                    var indexOfSpecialtyColumn = $scope.vm.dtColumns.indexOf(specialtyColumn[0]);
                    $scope.vm.dtColumns[indexOfSpecialtyColumn].sTitle = $scope.vm.specialtyString;
                }
                var querySpecialtyColumn = $scope.vm.dtColumns.filter(x => x.mData === 'querySpecialty');
                if (querySpecialtyColumn.length > 0) {
                    var indexOfQuerySpecialtyColumn = $scope.vm.dtColumns.indexOf(querySpecialtyColumn[0]);
                    $scope.vm.dtColumns[indexOfQuerySpecialtyColumn].sTitle = 'Query ' + $scope.vm.specialtyString;
                }
            }
        );

        materialButtons.render();

        materialButtons.processing();

        // This is needed to obtain the sum of datatable column values
        jQuery.fn.dataTable.Api.register( 'sum()', function ( ) {
            return this.flatten().reduce( function ( a, b ) {
                if ( typeof a === 'string' ) {
                    a = a.replace(/[^\d.-]/g, '') * 1;
                }
                if ( typeof b === 'string' ) {
                    b = b.replace(/[^\d.-]/g, '') * 1;
                }

                return a + b;
            }, 0 );
        } );

        $scope.initCallback = function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {

            // Datatables has finished init
            // Initialise searching
            if ($scope.vm.datatableApi)
                return;

            $scope.vm.datatableApi = this.api();

            // setup search filters
            search();

            // set the table to a fixed height, so it never collapsed up and down
            $('#auditTable').closest(".dataTables_scrollBody").height(300);

        }

        $scope.drawCallback = function (nRow) {

            // tell DataTables we're using Aussie-formatted dates for ordering
            $.fn.dataTable.moment('DD/MM/YYYY');
            $.fn.dataTable.moment('DD/MM/YYYY HH:mm');

            var table = $('#auditTable').DataTable(),
                total = 0;

            for (var i = 0; i < table.data().length; i++) {
                if (parseFloat(table.data()[i].projectedWiesDifference))
                    total += parseFloat(table.data()[i].projectedWiesDifference);
            }

            $('.reports__stats #total-queries').html('Total Queries: ' + table.data().count().toLocaleString());

            $('.reports__stats #total-proj-wies').html('Total Projected ' + $scope.vm.episodeValue + ' Difference: ' + total.toFixed(4));
        }

        this.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
                url: $scope.vm.initUrl,
                type: 'GET',
                error: (xhr, error, thrown) => {
                    if (thrown == 'Unauthorized' && $rootScope.globals.currentUser) {
                        console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
                    }
                }
            })
            .withDisplayLength(CONST.TABLEROWS)
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('sAjaxDataProp', '')
            .withOption('bLengthChange', false)
            .withPaginationType('simple_numbers')
            .withOption('drawCallback', $scope.drawCallback)
            .withOption('initComplete', $scope.initCallback)
            .withOption('scrollY', '300px')
            .withOption('scrollX', 'auto')
            .withOption('aaSorting', [
                [2, 'asc']
            ])
            .withOption('dom', '<"wrapper"rt<"table-footer"iBp>>')
            .withButtons([
                {
                    extend: 'print',
                    text: ''
                }, {
                    extend: 'csvHtml5',
                    text: '',
                    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
                }, {
                    extend: 'excelHtml5',
                    text: '',
                    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
                }, {
                    text: '',
                    action: function (e, dt, node, config) {
                        dt.ajax.reload();
                    }
                }
            ])
            .withColumnFilter({
            //sPlaceHolder: "head:after",
            aoColumns: [
                { type: 'number' },
                { type: "date-range" },
                { type: "date-range" },
                { type: "select" },
                { type: "date-range" }
            ]
        });

        function yesNo(data) {
            return (data === true) ? "Y" : "N";
        }

        this.dtColumns = [
            DTColumnBuilder.newColumn('episodeQueryId').withTitle('Query ID').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('campus').withTitle('Campus').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('urn').withTitle('UR Number').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('admissionNumber').withTitle('Admission Number').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('admissionDate').withTitle('Admission Date').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('dischargeDate').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('episodeStatus').withTitle('Episode Status').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('coder').withTitle('Coder').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('auditType').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('queryType').withTitle('Query By').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('queryTemplateName').withTitle('Query Type').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('queryReason').withTitle('Query Reason').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('queryCreatedBy').withTitle('Query Created By').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('createdDate').withTitle('Query Created Date').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('clinicianResponse').withTitle('Clinician Response').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('queryStatus').withTitle('Query Status').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('sentCount').withTitle('Send Count').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('lastSend').withTitle('Last Send Date').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('lastSendBy').withTitle('Last Send By').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('queryCategory').withTitle('Query Category').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('querySpecialty').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('currentDrg').withTitle('Current DRG').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('currentWies').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('projectedWies').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn(null).withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')
            .renderWith(function (data, type, full) {
                full['projectedWiesDifference'] = data['projectedWies'] ? data['projectedWies'] - data['currentWies'] : '';
                return data['projectedWies'] ? (data['projectedWies'] - (data['currentWies'] ? data['currentWies'] : 0.0000)).toFixed(4) : '';
            }),
            DTColumnBuilder.newColumn('wiesDiff').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'),
            DTColumnBuilder.newColumn('patientClassification').withTitle('Patient Classification').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')

        ];

        // Search filters
        this.campus = {
            selectedCampus: []
        };
        this.campusOptions = [];

        this.specialty = {
            selectedSpecialty: []
        };
        this.specialtyOptions = [];

        this.auditType = {
            selectedAuditType: []
        };
        this.auditTypeOptions = [];

        this.queryTemplate = {
            selectedQueryTemplates: []
        };
        this.queryTemplateData = {};
        this.queryTemplateOptions = [];
        this.episodeActive = {
            selectedEpisodeActive: ['YES']
        };
        this.episodeActiveOptions = ['YES', 'NO'];

        $scope.promise = Constants.getQueryTemplateData()
        .then(function (data) {
            $scope.vm.queryTemplateData = data;
            angular.forEach($scope.vm.queryTemplateData, function(value, key) {
                $scope.vm.queryTemplateOptions.push(value.queryTemplateName);
            });
        });

        this.queryType = {
            selectedQueryType: []
        };
        this.queryTypeOptions = [];

        this.queryStatus = {
            selectedQueryStatus: []
        };

        this.queryStatusOptions = [];

        this.querySpecialty = {
            selectedQuerySpecialty: []
        };

        QueryModalOptions.statuses().then(function (response) {
            angular.forEach(response, function (item, key) {
                $scope.vm.queryStatusOptions.push(item.name);
            });
        });

        Constants.getDivisionAndSpecialtyData().then(
          function successCallback(response) {
            $scope.vm.specialtyOptions = response.specialties.sort();
          }
        );

        this.startDatePicker = {
            input: {
                date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
                dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
            }
        };
        this.endDatePicker = {
            input: {
                date: moment().locale(this.locale).subtract(1, 'days'),
                dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
            }
        };

        this.coder = {
            selectedCoder: []
        };
        this.coderOptions = [];

        this.queryCreatedBy = {
            selectedQueryCreatedBy: []
        };

        CoderService.data().then(
            function successCallback(response) {
                angular.forEach(response, function (item, key) {
                    $scope.vm.coderOptions.push(item.name);
                });
            }
        );

        // callbacks for lx-selects and lx-date-picker
        datePicker.autoClose($scope);
        this.filterCallback = filterCallback;

        function filterCampus(swap) {
            $scope.vm.campus.selectedCampus = [];
            if (swap !== 'minus') {
                $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
            }
        }

        function filterSpecialty(swap) {
          $scope.vm.specialty.selectedSpecialty = [];
          if (swap === 'add') {
            $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
          }
        }

        function filterEpisodeActive(swap) {
          $scope.vm.episodeActive.selectedEpisodeActive = [];
          if (swap === 'add') {
            $scope.vm.episodeActive.selectedEpisodeActive = ['YES', 'NO'];
          }
        }

        function filterAuditType(swap) {

            // audit type
            $scope.vm.auditTypeOptions = CONST.AUDITTYPE;
            $scope.vm.auditType.selectedAuditType = [];

            if (swap !== 'minus') {

                angular.forEach(CONST.AUDITTYPE, function(value, key) {
                    $scope.vm.auditType.selectedAuditType.push($scope.vm.auditTypeOptions[$scope.vm.auditTypeOptions.indexOf(value)]);
                });

            }

        }

        function filterQueryType(swap) {
            // query type
            $scope.vm.queryType.selectedQueryType = [];

            if (swap !== 'minus') {
                $scope.vm.queryType.selectedQueryType = [$scope.vm.queryTypeOptions[0]];
            }
        }

        function filterQueryTemplate(swap) {

            // query type
            $scope.vm.queryTemplate.selectedQueryTemplates = [];

            if (swap !== 'minus') {
                $scope.vm.queryType.selectedQueryTemplates = $scope.vm.queryTemplateOptions;
            }

        }

        function filterQueryStatus(swap) {

            // query status
            $scope.vm.queryStatus.selectedQueryStatus = [];

            if (swap !== 'minus') {
                $scope.vm.queryType.selectedQueryStatus = $scope.vm.queryStatusOptions;
            }

        }

        function filterQuerySpecialty(swap) {

            $scope.vm.querySpecialty.selectedQuerySpecialty = [];

            if (swap !== 'minus') {
                $scope.vm.querySpecialty.selectedQuerySpecialty = $scope.vm.specialtyOptions;
            }

        }

        function filterCoder(swap) {

            $scope.vm.coder.selectedCoder = [];

            if (swap !== 'minus') {
                $scope.vm.coder.selectedCoder = $scope.vm.coderOptions;
            }

        }

        function filterQueryCreatedBy(swap) {

            $scope.vm.queryCreatedBy.selectedQueryCreatedBy = [];

            if (swap !== 'minus') {
                $scope.vm.queryCreatedBy.selectedQueryCreatedBy = $scope.vm.coderOptions;
            }

        }

        function filterCallback(_newValue, _oldValue) {
            $scope.vm.changeData();
        }

        function checkParam(param) {

            if (param && param.length !== 0) {
                return encodeURIComponent(param.join());

            } else {

                return '';

            }

        }

        this.changeData = changeData;

        function changeData() {
            var campus = '';
            if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
              if ($scope.vm.user.role !== 'Administrator' && $scope.vm.campus.selectedCampus.length === 0) {
                campus = $scope.vm.user.campus;
              } else {
                campus = $scope.vm.campus.selectedCampus;
              }
            } else {
              campus = $scope.vm.campus.selectedCampus;
            }
            var newUrl = $scope.vm.url
                         + '?startDate=' + $scope.vm.startDatePicker.input.dateFormatted
                         + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted
                         + '&speciality=' + checkParam($scope.vm.specialty.selectedSpecialty)
                         + '&campus=' + checkParam(campus)
                         + '&auditType=' + checkParam($scope.vm.auditType.selectedAuditType)
                         + '&queryType=' + checkParam($scope.vm.queryType.selectedQueryType)
                         + '&queryTemplate=' + checkParam($scope.vm.queryTemplate.selectedQueryTemplates)
                         + '&queryStatus=' + checkParam($scope.vm.queryStatus.selectedQueryStatus)
                         + '&querySpecialty=' + checkParam($scope.vm.querySpecialty.selectedQuerySpecialty)
                         + '&coder=' + checkParam($scope.vm.coder.selectedCoder)
                         + '&episodeActive=' + checkParam($scope.vm.episodeActive.selectedEpisodeActive)
                         + '&queryCreatedBy=' + checkParam($scope.vm.queryCreatedBy.selectedQueryCreatedBy);

            $scope.vm.datatableApi.ajax.url(newUrl).load().draw();

        }

        function search() {
            // delete any global searches previously applied
            if ($.fn.dataTable.ext.search.length === 1)
                $.fn.dataTable.ext.search.shift();

            var auditTable = $scope.vm.datatableApi;
            var clearAuditTable = auditTable.search('').draw();

            filterCampus('minus');
            filterSpecialty('minus');
            filterAuditType('minus');
            filterQueryType('minus');
            filterQueryStatus('minus');
            filterQuerySpecialty('minus');
            filterCoder('minus');
            filterQueryCreatedBy('minus');

            // re-draw tabele on datepicker close
            $scope.$on('lx-date-picker__close-start', function(e, id) {

                $scope.vm.changeData();

            });

        }

        // bind the datatable instance to an object to monitor loading
        this.dtInstanceCallback = dtInstanceCallback;

        function dtInstanceCallback(dtInstance) {

            $scope.dtInstance = dtInstance._renderer;

        }

        // bind filter swap
        this.filterSwap = filterSwap;

        function filterSwap(thisFilter, thisModifier) {


            switch (thisFilter) {

                case 'campus':

                    if (thisModifier === 'add') {

                        filterCampus('add');

                    } else {

                        filterCampus('minus');

                    }

                    break;

                case 'auditType':

                    if (thisModifier === 'add') {

                        filterAuditType('add');

                    } else {

                        filterAuditType('minus');

                    }

                    break;

                case 'episodeActive':

                    if (thisModifier === 'add') {

                        filterEpisodeActive('add');

                    } else {

                        filterEpisodeActive('minus');

                    }

                    break;

                case 'specialty':

                    if (thisModifier === 'add') {

                        filterSpecialty('add');

                    } else {

                        filterSpecialty('minus');

                    }

                    break;

                case 'queryType':

                    if (thisModifier === 'add') {

                        filterQueryType('add');

                    } else {

                        filterQueryType('minus');

                    }

                    break;

                case 'queryTemplate':

                    if (thisModifier === 'add') {

                        filterQueryTemplate('add');

                    } else {

                        filterQueryTemplate('minus');

                    }

                    break;

                case 'queryStatus':

                    if (thisModifier === 'add') {

                        filterQueryStatus('add');

                    } else {

                        filterQueryStatus('minus');

                    }

                    break;

                case 'querySpecialty':

                    if (thisModifier === 'add') {

                        filterQuerySpecialty('add');

                    } else {

                        filterQuerySpecialty('minus');

                    }

                    break;

                case 'coder':

                    if (thisModifier === 'add') {

                        filterCoder('add');

                    } else {

                        filterCoder('minus');

                    }

                    break;

                case 'queryCreatedBy':

                    if (thisModifier === 'add') {

                        filterQueryCreatedBy('add');

                    } else {

                        filterQueryCreatedBy('minus');

                    }

                    break;

                default:
                    break;
            }

        }


    }
}

export default QueriesController;



// WEBPACK FOOTER //
// ./client/app/common/reports/queries/queries.controller.js